import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EnvironmentProvider } from '../context';
import { EnvMain } from './EnvMain';
import { EnvSidebar } from './EnvSidebar';

const DevEnvDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row">
      <EnvironmentProvider>
        <EnvSidebar />
        <EnvMain />
        <button
          type="button"
          onClick={() => navigate('/dev/new')}
          className="absolute bottom-5 right-5 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center"
        >
          +
        </button>
      </EnvironmentProvider>
    </div>
  );
};

export default DevEnvDetail;
